import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
 faCheck,
 faCopy,
 faEye
} from "@fortawesome/free-solid-svg-icons";
import credentials from "../../assets/credentials";
const UrlBox = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(`${credentials.SITE_URL}/${text}`);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative bg-gray-900 text-white rounded-lg p-4 pt-1 pl-0 w-full max-w-lg flex flex-col flex-wrap">
      <pre className="whitespace-pre-wrap break-words font-mono text-sm bg-white/10 p-1 w-full rounded-lg">
        {`${credentials.SITE_URL}/${text}`}
      </pre>
      <div className="flex flex-row justify-center flex-nowrap absolute -top-2 right-5 gap-4"> 
      <button
        onClick={handleCopy}
        className=" bg-gray-700 hover:bg-yellow-600  px-1 rounded-full transition"
      >
        {copied ? (
          <FontAwesomeIcon icon={faCheck} size="sm"/>
        ) : (
          <FontAwesomeIcon icon={faCopy} size="sm"/>
        )}
      </button>

      <button className=" bg-gray-700 hover:bg-yellow-600 px-1 rounded-full transition"><Link to={`${credentials.SITE_URL}/${text}`}> <FontAwesomeIcon icon={faEye} size="sm"/></Link></button>
      </div>
    </div>
  );
};

export default UrlBox;
